<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :isDashboardView="false"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="saveActivity" method="POST">
                <h2>WHAT ARE YOU DOING</h2>
                <p>
                    <admin-select class="col-md-3" name="priceAction" v-model="selectedActivity" required>
                        <option></option>
                        <option v-for="(action,id) in actions" :value="id">{{ action }}</option>
                    </admin-select>
                </p>
                <br />
                <p v-if="showDeviationVersion" id="deviation_version_container">
                    <strong>Specify Deviation Type:</strong><br />
                    <admin-select class="col-md-3" name="deviation_version" id="deviation_version" v-model="deviationVersion" :required="showDeviationVersion">
                        <option></option>
                        <option value="single">Single Submission</option>
                        <option value="multi">Multi Submission</option>
                    </admin-select>
                </p>
                <br />
                <br />
                <button class="btn-round-red" type="submit">NEXT STEP ></button>
            </form>

            <div id="additionalResourcesDiv">
                <h3>ADDITIONAL RESOURCES</h3>
                <div id="additionalResourcesContent">
                    <div class="additionalResourceCard">
                        <div class="additionalResourceLabel">
                            <span>Retail Non-Workflow Price Request Template</span>
                        </div>
                        <a href="/archive/pricing-templates/US-R-Deviated-Price-Request-Template.xlsb" class="additionalResourceButton">
                            Download
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            actions:[],
            deviationVersion:"",
            selectedActivity:""
        }
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            priceERPAdmins: state => state.priceERPAdmins,
        }),
        isPriceERPAdmin() {
            return this.priceERPAdmins.includes(this.user.id);
        },
        showDeviationVersion() {
            return [1, 2].includes(Number(this.selectedActivity));
        }
    },
    methods: {
        saveActivity() {
            const payload = {
                userId: this.user.id,
                selectedActivity: this.selectedActivity,
            }

            if(this.showDeviationVersion) {
                payload.deviationVersion = this.deviationVersion;
            }

            axios.post(`/api/saveActivity`, payload)
                .then((response) => {
                    let submissionId = response.data;
                    if(this.selectedActivity === "8") {
                        this.$router.push({
                            name: "PumaPromoDetails",
                            params: { ppId: submissionId }
                        });
                    } else {
                        this.$router.push({
                            name: "PriceWorkflowCompanySelect",
                            params: { ppId: submissionId }
                        });
                    }
                })
                .catch((error) => {
                    console.error("saveActivity failed");

                    if (error.response) {
                        console.error("Status:", error.response.status);
                        console.error("Response data:", error.response.data);
                    } else if (error.request) {
                        console.error("No response received:", error.request);
                    } else {
                        console.error("Axios error:", error.message);
                    }
                }
            );
        }
    },
    created() {
        axios.get(`/api/getAllActions`).then(response => {
            this.actions = response.data;
        });
    },
};
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #additionalResourcesDiv {
        width: 100%;
        clear: both;
        margin-top: 1.25rem;
    }

    #additionalResourcesDiv h3 {
        font-family: 'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #additionalResourcesContent {
        max-width: 46rem;
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
    }

    .additionalResourceCard {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.85rem 1rem;
        border: 1px solid #e8e8ee;
        border-radius: 12px;
        background: #efefef;
        box-shadow: 0 1px 2px rgba(0,0,0,0.04);
    }

    .additionalResourceLabel {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        min-width: 0;
    }

    .additionalResourceLabel span {
        font-weight: 600;
    }

    .additionalResourceButton {
        background-color: #4368c8 !important;
        padding: 0.45rem 0.95rem;
        border-radius: 10px;
        font-weight: 600;
        font-size: 0.9rem;
        white-space: nowrap;
        color: #fff;
        text-decoration: none;
    }
</style>
